export default "__VITE_ASSET__u4m4LgoGnSNMMzNs726OyA__"